import { createFileRoute } from '@tanstack/react-router'

import {
  requireSession,
  type TrialSource,
  TrialStartPage,
} from '@/modules/auth'

interface TrialStartSearch {
  name: string
  role?: string
  trial_source?: TrialSource
}

const isTrialSource = (value: unknown): value is TrialSource =>
  typeof value === 'object' && value !== null

export const Route = createFileRoute('/trial_/add-card')({
  staticData: { title: 'Start your free trial' },
  beforeLoad: requireSession,
  // A firm name like "1199" parses as a number from the query, so it is read back as text.
  validateSearch: (search: Record<string, unknown>): TrialStartSearch => ({
    name: search.name === undefined ? '' : String(search.name),
    role: typeof search.role === 'string' ? search.role : undefined,
    trial_source: isTrialSource(search.trial_source)
      ? search.trial_source
      : undefined,
  }),
  component: TrialStart,
})

function TrialStart() {
  const { name, role, trial_source } = Route.useSearch()
  return <TrialStartPage details={{ name, role, trialSource: trial_source }} />
}
